var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 122,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 68,
  height: 8,
  x: 53.201,
  y: 8,
  fill: "var(--hop-neutral-border-weak)",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  d: "M1.799 12c0-6.075 4.925-11 11-11h16c6.075 0 11 4.925 11 11s-4.925 11-11 11h-16c-6.075 0-11-4.925-11-11Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28.799,
  cy: 12,
  r: 8,
  fill: "var(--hop-neutral-surface-strong)"
})));
export default SvgSwitch;